var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-datepicker',{attrs:{"md-immediately":""},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}},[_c('label',[_vm._v("\n    "+_vm._s(_vm.optionData.title)+":\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }